import {Amplify} from 'aws-amplify';

import {stage} from '../config/stage';

// get config
import {config} from '../config/amplify';
import {ConsoleLogger} from 'aws-amplify/utils';

Amplify.configure(config);

stage === 'ide'
    ? (ConsoleLogger.LOG_LEVEL = 'DEBUG')
    : (ConsoleLogger.LOG_LEVEL = 'INFO');

(window as unknown as { LOG_LEVEL: string }).LOG_LEVEL = 'DEBUG';
